import Ajax from "base/Ajax";
import Page from "webPage/Page";
import {svg_include} from "index";

export default class Resources {

    constructor($element) {
        this.$element = $element;

        this.$filters = this.$element.find('.js-filter');
        this.$resources = this.$element.find('.js-resources-section');

        this.$pagination = this.$element.find('.js-pagination');

        this.request = null;

        this.filters = {};

        this.bindEvents();

        this.getLatestFilters();
    }

    bindEvents() {
        let me = this;

        this.$element.on('change', '.js-filter-value', () => {
            if ($(window).outerWidth() >= Resources.SIDEBAR_SIZE) {
                this.getLatestFilters();
                this.getResources(true);
            }
            return false;
        }).on('click', '.js-change-page', function () {
            me.filters.page = parseInt($(this).attr('data-page'));
            me.getResources(true);

            return false;
        }).on('click', '.js-apply-changes', () => {
            this.getLatestFilters();
            this.getResources(true);

            $('body').removeClass('show-filter');
            return false;
        }).on('click', '.js-close-filter', () => {
            this.updateFilters();

            $('body').removeClass('show-filter');
            return false;
        }).on('click', '.js-filter-title', function () {
            me.$filters.toggleClass('filter--active');
        });

        window.onpopstate = function (event) {
            let filters = {};

            let pageRegexp = new RegExp('^.*/page/([0-9]+)/?');
            let pagePattern = pageRegexp.exec(window.location.pathname);

            if (pagePattern !== null && 'undefined' !== typeof pagePattern[0]) {
                filters.page = pagePattern[1];
            }

            let queryString = Page.get_query();

            me.filters = $.extend(true, {}, filters, queryString);

            me.updateFilters();
            me.getResources(false);
        }
    }


    clearFilters() {
        this.$filters.find('input[type="checkbox"]').prop('checked', false);
    }

    updateFilters() {
        this.clearFilters();

        Object.keys(this.filters).forEach((key) => {
            if ('undefined' !== typeof key) {
                let value = this.filters[key];
                if (Array.isArray(value)) {
                    value.forEach((filter) => {
                        this.$filters.find('input[type="checkbox"][name="' + key + '[]"][value="' + filter + '"]').prop('checked', true);
                    });
                } else {
                    this.$filters.find('input[type="checkbox"][name="' + key + '"][value="' + value + '"]').prop('checked', true);
                }
            }
        });
    }

    getLatestFilters() {
        this.filters = this.$filters.serializeJSON();
    }

    getResources(pushState) {
        this.$resources.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wp/v2', 'resources', this.filters);
        this.updateFilters();

        this.request.then((data) => {
            this.request = null;
            this.$resources.removeClass('loading');

            let headers = {};
            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }

            this.updateResources(data, headers);
        }).catch((e) => {
            this.request = null;
            this.$resources.removeClass('loading');
            console.log(e);
        });

        if (pushState) {
            history.pushState({}, '', this.fullPageUrl());
        }
    }

    pageUrl() {
        return window.location.pathname.replace(/page\/[0-9]\//g, '');
    }

    fullPageUrl() {
        let base = this.pageUrl();

        let page = '';

        if ('undefined' !== typeof this.filters.page && this.filters.page > 1) {
            page = 'page/' + this.filters.page + '/';
        }

        let queryString = this.pageQueryString();

        return base + page + queryString;
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        link += this.pageQueryString(link);

        return link;
    }

    pageQueryString() {
        let queryString = '';
        let filters = Object.assign({}, this.filters);

        delete filters.page;

        if (Object.keys(filters).length > 0) {
            queryString += "?" + $.param(filters).replace(/%5B%5D/g, "[]");
        }

        return queryString;
    }

    updateResources(data, headers) {
        if ('undefined' !== typeof data && data.length > 0) {
            let $wrapper = eotwJSXFactory('div', {className: "resource-list"});
            data.forEach((resource) => {
                $wrapper.append(this.buildResource(resource));
            });
            this.$resources.html(
                $wrapper
            );
        } else {
            this.showNoResourcesMessage();
        }

        this.buildPagination(data, headers);
    }

    buildPagination(data, headers) {
        this.$pagination.html('');

        if ('undefined' === typeof headers['x-wp-totalpages']) return;
        let total_pages = parseInt(headers['x-wp-totalpages']);
        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;
        let range = 2;
        let show_items = (range * 2) + 1;

        let base = this.pageUrl();

        let $pagination = (
            eotwJSXFactory('section', {className: "pagination"})
        );

        let $wrap = (eotwJSXFactory('div', {className: "pagination__wrap js-wrap"}));

        if (page > 1) {
            $wrap.append(
                eotwJSXFactory('a', {href: this.getPageLink(base, page - 1) + this.pageQueryString(base), 'data-page': page - 1, className: "pagination__direction-link js-change-page"}, [
                    eotwJSXFactory('span', {className: "pagination__direction-link-icon", unsafeHtml: svg_include('breadcrumb-arrow')}),
                    eotwJSXFactory('span', {className: "pagination__direction-link-text"}, ["Previous"])
                ])
            );
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= total_pages; i++) {
            if (1 !== total_pages && (!(i >= page + range + 1 || i <= page - range - 1) || total_pages <= show_items)) {
                $list.append(
                    eotwJSXFactory('li', {className: "pagination__item"}, [
                        page === i ? (
                            eotwJSXFactory('span', {className: "pagination__link pagination__link--active"}, [i])
                        ) : (
                            eotwJSXFactory('a', {href: this.getPageLink(base, i) + this.pageQueryString(base), 'data-page': i, className: "pagination__link js-change-page"}, [i])
                        )
                    ]),
                );
            }
        }

        $wrap.append($list);

        if (page < total_pages) {
            $wrap.append(
                eotwJSXFactory('a', {href: this.getPageLink(base, page + 1) + this.pageQueryString(base), 'data-page': page + 1, className: "pagination__direction-link pagination__direction-link--next js-change-page"}, [
                    eotwJSXFactory('span', {className: "pagination__direction-link-text"}, ["Next"]),
                    eotwJSXFactory('span', {className: "pagination__direction-link-icon", unsafeHtml: (svg_include('breadcrumb-arrow'))})
                ])
            );
        }

        $pagination.append($wrap);

        this.$pagination.html($pagination);
    }

    showNoResourcesMessage() {
        this.$resources.html(
            eotwJSXFactory('div', {className: "empty-message"}, [
                eotwJSXFactory('p', null, ["Sorry there are currently no resources available, check back soon."])
            ])
        );
    }

    buildResource(resource) {
        return (
            eotwJSXFactory('div', {className: "resource"}, [
                eotwJSXFactory('div', {className: "resource__icon"}, [
                    eotwJSXFactory('div', {className: "resource__icon-file"}, [
                        'undefined' !== typeof resource['file_icon_url'] ? (eotwJSXFactory('img', {src: resource['file_icon_url']})) : ''
                    ]),
                    eotwJSXFactory('div', {className: "resource__file-size"}, ['undefined' !== typeof resource['file_size'] ? resource['file_size'] : ''])
                ]),
                eotwJSXFactory('div', {className: "resource__text"}, [
                    eotwJSXFactory('div', {className: "resource__heading heading heading--6"}, ['undefined' !== typeof resource.title.rendered ? resource.title.rendered : '']),
                    eotwJSXFactory('div', {className: "resource__category"}, ['undefined' !== typeof resource['term_string'] ? resource['term_string'] : ''])
                ]),
                eotwJSXFactory('a', {href: 'undefined' !== typeof resource.link ? resource.link : '', className: "resource__link"}, ["Read More ", eotwJSXFactory('span', {className: "resource__link-icon", unsafeHtml: (svg_include('btn-icon'))})])
            ])
        )
    }
}

Resources.SIDEBAR_SIZE = 760;
